import TrustPilotRebrand from '@/assets/image/free-to-pay/trust-pilot-svg/trust-pilot-rebrand.svg';
import Image, { type ImageProps } from 'next/image';

export const TrustPilotSvg = (props: Omit<ImageProps, 'src'>) => {
  const { alt = 'trust pilot', ...rest } = props;

  return <Image src={TrustPilotRebrand} alt={alt} {...rest} />;
};
